// src/components/Careers/LifeAndPeople/EmployeeCard.js
import React from 'react';
import './EmployeeCard.css';

function EmployeeCard({ name, quote, imageUrl }) {
  return (
    <div className="employee-card">
      <div className="employee-image-container">
        <img src={imageUrl} alt={name} className="employee-image" />
      </div>
      <div className="employee-card-content">
        <h3 className="employee-name">{name}</h3>
        <p className="employee-quote">{quote}</p>
      </div>
    </div>
  );
}

export default EmployeeCard;